import { useEffect } from "react";

type HotkeyAction = {
  code: string;
  onKeyDown?: () => void;
  onKeyUp?: () => void;
  preventDefault?: boolean;
};

type Options = {
  targetElement?: HTMLElement | null;
};

export const useHotkeys = (hotkeys: HotkeyAction[], options?: Options) => {
  useEffect(() => {
    const { targetElement } = options || {};

    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      )
        return;
      if (targetElement && document.activeElement !== targetElement) return;

      hotkeys.forEach(({ code, onKeyDown, preventDefault }) => {
        if (e.code === code) {
          if (preventDefault) e.preventDefault();
          onKeyDown?.();
        }
      });
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      )
        return;
      if (targetElement && document.activeElement !== targetElement) return;

      hotkeys.forEach(({ code, onKeyUp, preventDefault }) => {
        if (e.code === code) {
          if (preventDefault) e.preventDefault();
          onKeyUp?.();
        }
      });
    };

    // keydown, keyup 이벤트 리스너 추가
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    // cleanup 함수: 컴포넌트가 언마운트되거나 변경될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [hotkeys, options]);
};
